hg<template>
  <div class="detail">
    <p>
      <i class="el-icon-s-home"></i>
      <span>网站首页</span>
      / 政策法规/ {{ typeName }}
    </p>

    <div class="content" v-html="detail"></div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: "",
      typeName: "",
    };
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name == "detail") {
          this.getData(route.query.id);
        }
      },
    },
  },
  mounted() {
    var id = this.$route.query.id;
    this.getData(id);
  },
  methods: {
    // 获取数据
    getData(id) {
      this.$axios({
          url: "http://copyright.gzcc315.com/policies",
          data: { id: id },
      }).then((res) => {
        this.typeName = res.data.title;
        this.detail = res.data.content;
      })
    },
  },
};
</script>
<style scoped>
.detail > p {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  color: gray;
}

.detail > p i {
  margin-right: 10px;
}

.detail > p span:hover {
  color: #016fb8;
  cursor: pointer;
}

.detail .content {
  line-height: 30px;
  padding: 20px 30px;
  box-sizing: border-box;
  color: gray;
  font-size: 13px;
}
</style>
